import Axios from "axios";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { getCurrentYearMonth } from "./DateUtils";

// ดึงข้อมูลจาก Table ใดๆ ก็ได้
export async function getData(table, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data`,
      {
        table: table,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ แต่ต้องเป็น Comp_Id ตามล็อกอิน
export async function getDataWithComp(table, order) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data-with-comp`,
      {
        table: table,
        order: order,
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ และสามารถ JOIN Table ได้ด้วย
export async function getDataWithJoin(select, table, join, order) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data-with-join`,
      {
        select: select,
        table: table,
        join: join,
        order: order,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Database (สำหรับรายงาน)
export async function getDataByQuery(query) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get`,
      {
        query: query,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// นับรายการจาก Table ใดๆ ก็ได้ แต่ต้องเป็น Comp_Id ตามล็อกอิน
export async function countData(table, where) {
  const response = await Axios.post(
    `${process.env.REACT_APP_API_URL}/api/count-data`,
    {
      table: table,
      where: where,
      comp_id: window.localStorage.getItem("company"),
    },
    {
      headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
    }
  );
  return response.data[0].Count;
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ DocId
export async function getByDocId(table, docId, andOrder) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-doc-id`,
      {
        table: table,
        doc_id: docId,
        and_order: andOrder,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ RecId
export async function getByRecId(table, recId, andOrder) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-rec-id`,
      {
        table: table,
        rec_id: recId,
        and_order: andOrder,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ PayId
export async function getByPayId(table, payId, andOrder) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-pay-id`,
      {
        table: table,
        pay_id: payId,
        and_order: andOrder,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Tb_Set_Company
export async function getCompany() {
  try {
    const response = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-company`,
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Tb_Set_DocType
export async function getDocType(docCode) {
  try {
    // const response = await Axios.get(`${process.env.REACT_APP_API_URL}/api/get-doc-type`, {
    //     headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
    // });
    // return response.data;

    const response = await getData(
      "Tb_Set_DocType",
      `DocType_Status = 'Y' AND DocType_DocCode = ${docCode}`
    );

    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Tb_Set_TransType
export async function getTransType() {
  try {
    const response = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-trans-type`,
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Tb_Set_DocStatusColour
export async function getDocStatusColour(docCode, docField) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-doc-status-colour`,
      {
        doc_code: docCode,
        doc_field: docField,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก View_Set_Pr
export async function getViewPrH() {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-pr-h`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก View_Set_Po
export async function getViewPoH() {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-po-h`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก View_Set_Ap
export async function getViewAp() {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-ap`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก View_Set_Item
export async function getViewItem() {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-item`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก API_0701_SO_H ที่ยังไม่ได้สร้าง Picking List
export async function getSoWithoutPK() {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-so-by-picking-list`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลลูกค้าจาก API_1001_WHDOC_H ที่ GROUP BY เฉพาะลูกค้า
export async function getCustByType(whDocType, condition) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-cust-by-wh-doc-type`,
      {
        wh_doc_type: whDocType,
        comp_id: window.localStorage.getItem("company"),
        condition: condition,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลลูกค้าจาก API_1001_WHDOC_H ที่ GROUP BY เฉพาะพนักงาน
export async function getEmpByType(wtDocType, condition) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-emp-by-wh-doc-type`,
      {
        wt_doc_type: wtDocType,
        comp_id: window.localStorage.getItem("company"),
        condition: condition,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// Popup แจ้งเตือน ต่างๆ
export function getAlert(status, message, callback) {
  let icon = "";
  let confirmButtonClass = "";
  let cancelButtonClass = "btn btn-danger";

  switch (status) {
    case "OK":
      icon = "success";
      confirmButtonClass = "btn btn-success";
      break;
    case "FAILED":
      icon = "error";
      confirmButtonClass = "btn btn-danger";
      break;
    case "WARNING":
      icon = "warning";
      confirmButtonClass = "btn btn-warning";
      break;
    case "INFO":
      icon = "info";
      confirmButtonClass = "btn btn-info";
      break;
    case "C_DIALOG":
      icon = message === "ยืนยันการลบข้อมูล" ? "question" : "info";
      confirmButtonClass = "btn btn-lg btn-success";
      cancelButtonClass = "btn btn-lg btn-danger";
      Swal.fire({
        title: message,
        icon: icon,
        showCancelButton: true,
        buttonsStyling: true,
        customClass: {
          confirmButton: confirmButtonClass,
          cancelButton: cancelButtonClass,
        },
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          if (callback) {
            callback(true);
          }
        } else {
          if (callback) {
            callback(false);
          }
        }
      });
      return;
    default:
      console.error(`Invalid status: ${status}`);
      return;
  }

  // เลื่อนหน้าขึ้นด้านบนสุด
  window.scrollTo(0, 0);

  Swal.fire({
    title: message,
    icon: icon,
    buttonsStyling: false,
    customClass: {
      confirmButton: confirmButtonClass,
    },
  });
}

// ฟังก์ชันสำหรับจัดรูปแบบจำนวนเงิน
export function formatCurrency(amount, isItemPriceUnit = false) {
  const decimalPlaces = isItemPriceUnit ? 4 : 2;

  // ถ้า amount เป็น string แล้วให้ return ออกเลย
  if (typeof amount === "string") {
    return amount;
  }

  if (typeof amount !== "number" || isNaN(amount)) {
    return decimalPlaces === 4 ? "0.0000" : "0.00";
  }


  const formattedAmount = amount.toFixed(decimalPlaces);

  return formattedAmount.replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

export function parseCurrency(formattedAmount) {
  // ตรวจสอบว่า formattedAmount เป็น null หรือว่าง
  if (formattedAmount == null || formattedAmount === "") {
    return formattedAmount;
  }

  if (typeof formattedAmount === "number") return formattedAmount;
  if (typeof formattedAmount !== "string") return NaN;

  // ลบช่องว่างและเครื่องหมายพันหลัก ถ้าไปโดนฟังชั่น formatCurrency แปลงค่ามา
  const cleanedAmount = formattedAmount.replace(/,/g, "").trim();

  // แปลงค่ากลับไปเป็นตัวเลขเหมือนเดิม สมมุติ 100,400.00 จะแปลงเป็น 100400 (เคสที่พี่คินแจ้งมา)
  const numericValue = parseFloat(cleanedAmount);

  // ตรวจสอบว่าผลลัพธ์เป็นตัวเลขที่ถูกต้อง (ห้ามโยนกลับไปเป็น String เด็ดขาด ไม่งั้นเราจะชิปหายกันหมด)
  if (isNaN(numericValue)) {
    return formattedAmount;
  }

  // ปรับทศนิยมให้ตรงกับจำนวนที่ต้องการ (4 ตำแหน่ง)
  return Number(numericValue.toFixed(4));
}

// ฟังก์ชั่นเพิ่ม DocNo (For PR, PO)
export function getMaxDocNo(list, title) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return title + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return title + currentYear + currentMonth + "0001";
  }

  return incrementDocNo(maxDoc);
}
// ฟังก์ชั่นเพิ่มเสริม DocNo (For PR, PO)
export function incrementDocNo(docNo) {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
}

// ฟังก์ชั่นเพิ่ม RecNo
export function getMaxRecNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `REC${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Rec_No > max ? item.Rec_No : max;
  }, list[0].Rec_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `REC${currentYear}${currentMonth}0001`;
  }

  return incrementRecNo(maxRec);
}
export function getMaxRecNoForTest(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `REC${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.RecNo > max ? item.RecNo : max;
  }, list[0].RecNo);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `REC${currentYear}${currentMonth}0001`;
  }

  return incrementRecNo(maxRec);
}
// ฟังก์ชั่นเพิ่มเสริม RecNo
export function incrementRecNo(recNo) {
  const prefix = recNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(recNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นดึง Max ของ Pay
export function getMaxPayNo(list, givenDate) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  // แปลงวันที่จากรูปแบบ "13-09-2567" เป็นปีและเดือน
  let year, month;
  if (givenDate) {
    const [day, monthStr, yearStr] = givenDate.split("-");
    year = yearStr.slice(-2); // ดึงสองหลักสุดท้ายของปี พ.ศ.
    month = monthStr; // เดือน
  } else {
    year = currentYear;
    month = currentMonth;
  }

  // เช็คว่ามีข้อมูล Pay_No หรือไม่
  if (!list || list.length < 1) {
    return `PAY${year}${month}0001`;
  }

  // หาค่าสูงสุดของ Pay_No
  const maxPay = list.reduce((max, item) => {
    return item.Pay_No > max ? item.Pay_No : max;
  }, list[0].Pay_No);

  // เช็คปีและเดือนใน Pay_No ล่าสุด
  const maxPayYear = maxPay.slice(3, 5);
  const maxPayMonth = maxPay.slice(5, 7);

  if (maxPayYear !== year || maxPayMonth !== month) {
    return `PAY${year}${month}0001`;
  }

  return incrementPayNo(maxPay);
}
// ฟังก์ชั่นเพิ่มเสริม PayNo
export function incrementPayNo(payNo) {
  const prefix = payNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(payNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นดึง Max ของ Line
export async function getLineByDocId(table, docId) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-line-by-doc-id`,
      {
        table: table,
        doc_id: docId,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ฟังก์ชั่นเพิ่ม AdjNo
export function getMaxAdjNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `ADJ${currentYear}${currentMonth}0001`;
  }

  const maxAdj = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxAdj.slice(3, 5) !== currentYear ||
    maxAdj.slice(5, 7) !== currentMonth
  ) {
    return `ADJ${currentYear}${currentMonth}0001`;
  }

  return incrementAdjNo(maxAdj);
}
// ฟังก์ชั่นเพิ่มเสริม AdjNo
export function incrementAdjNo(adjNo) {
  const prefix = adjNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(adjNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นเพิ่ม TnsNo
export function getMaxTnsNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `TNS${currentYear}${currentMonth}0001`;
  }

  const maxTns = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxTns.slice(3, 5) !== currentYear ||
    maxTns.slice(5, 7) !== currentMonth
  ) {
    return `TNS${currentYear}${currentMonth}0001`;
  }

  return incrementTnsNo(maxTns);
}
// ฟังก์ชั่นเพิ่มเสริม TnsNo
export function incrementTnsNo(tnsNo) {
  const prefix = tnsNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(tnsNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นเพิ่ม WhDocNo (For WD)
export function getMaxWdNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "WD" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "WD" + currentYear + currentMonth + "0001";
  }

  return incrementWdNo(maxDoc);
}
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For WD)
export function incrementWdNo(docNo) {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
}

// ฟังก์ชั่นเพิ่ม WTDocNo (For OD)
export function getMaxOdNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "OD" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "OD" + currentYear + currentMonth + "0001";
  }

  return incrementOdNo(maxDoc);
}
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For OD)
export function incrementOdNo(docNo) {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
}

// ฟังก์ชั่นเพิ่ม WhDocNo (For IB)
export function getMaxIbNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "IB" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "IB" + currentYear + currentMonth + "0001";
  }

  return incrementIbNo(maxDoc);
}
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For IB)
export function incrementIbNo(docNo) {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
}

// ฟังก์ชั่นเพิ่ม WTDocNo (For TE)
export function getMaxTeNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "TE" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WTDoc_No > max ? item.WTDoc_No : max;
  }, list[0].WTDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "TE" + currentYear + currentMonth + "0001";
  }

  return incrementTeNo(maxDoc);
}
// ฟังก์ชั่นเพิ่มเสริม WTDocNo (For TE)
export function incrementTeNo(docNo) {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
}

// ฟังก์ชั่นเพิ่ม WTDocNo (For OE)
export function getMaxOeNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "OE" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WTDoc_No > max ? item.WTDoc_No : max;
  }, list[0].WTDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "OE" + currentYear + currentMonth + "0001";
  }

  return incrementOeNo(maxDoc);
}
// ฟังก์ชั่นเพิ่มเสริม WTDocNo (For OE)
export function incrementOeNo(docNo) {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
}

// ฟังก์ชั่นเพิ่ม INV_H (For CS)
export function getMaxCsNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "CS" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "CS" + currentYear + currentMonth + "0001";
  }

  return incrementCsNo(maxDoc);
}
// ฟังก์ชั่นเพิ่มเสริม INV_H (For CS)
export function incrementCsNo(docNo) {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
}

// ฟังก์ชั่นเพิ่ม INV_H (For DSR)
export function getMaxDsrNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `DSR${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน InvNo ล่าสุด
  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `DSR${currentYear}${currentMonth}0001`;
  }

  return incrementDsrNo(maxRec);
}
// ฟังก์ชั่นเพิ่มเสริม INV_H (For DSR)
export function incrementDsrNo(invNo) {
  const prefix = invNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(invNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นเพิ่ม InvNo
export function getMaxInvNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `INV${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน InvNo ล่าสุด
  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `INV${currentYear}${currentMonth}0001`;
  }

  return incrementInvNo(maxRec);
}
// ฟังก์ชั่นเพิ่มเสริม InvNo
export function incrementInvNo(invNo) {
  const prefix = invNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(invNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นเพิ่ม WhDocNo (For ST)
export function getMaxStNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "ST" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "ST" + currentYear + currentMonth + "0001";
  }

  return incrementStNo(maxDoc);
}
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For WD)
export function incrementStNo(docNo) {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
}

// ฟังก์ชัน randomDelay ใช้สำหรับทดสอบหน่วงเวลาดึงเลข Doc_No เบื้องต้น (ใช้ชั่วคราวไปก่อน)
export function randomDelay() {
  // const delay = Math.floor(Math.random() * 5000); // สุ่มหน่วงเวลา 0-5000 มิลลิวินาที
  // console.debug(`Random delay: ${delay} ms`);
  // return new Promise((resolve) => setTimeout(resolve, delay));
  return new Promise((resolve) =>
    setTimeout(resolve, Math.floor(Math.random() * 5000))
  );
}

export async function getPriceForIce(arCode, itemCode, itemQty) {
  const aItemIce = ['101', '102', '103', '104'];

  let itemPrice = 0.0;
  let itemTotal = 0.0;
  let nPrice = 0.0;
  let cArSpriceUse = 'N';
  let cItemSpriceUse = 'Y';
  let nArSpriceId = 0;

  // เก็บตัวแปรสำหรับ 3 กระสอบ
  let arIcePro = null;

  if (aItemIce.includes(itemCode)) {
    const result = await getDataWithComp('Tb_Set_AR', `AND AR_Code = '${arCode}'`);

    if (result && result.length > 0) {
      const firstRow = result[0];
      nPrice = firstRow?.Default_Price || 0.0;
      cArSpriceUse = firstRow?.AR_SPrice_use || 'N';
      nArSpriceId = firstRow?.AR_SPrice_id || 0;
      arIcePro = firstRow?.AR_ICE_Pro || null;
    }
  }

  const itemResult = await getDataWithComp('Tb_Set_Item', `AND Item_Code = '${itemCode}'`);

  if (itemResult && itemResult.length > 0) {
    const firstItemRow = itemResult[0];
    cItemSpriceUse = firstItemRow?.Item_SPrice_use || 'Y';
    const nItemId = firstItemRow?.Item_Id || 0;

    if (nPrice === 0.0) {
      itemPrice = firstItemRow?.Item_Price || 0.0;
    } else {
      itemPrice = nPrice;
    }

    let nProQty = 0.0;
    let nProPrice = 0.0;

    if (cArSpriceUse === 'Y' && cItemSpriceUse === 'Y') {
      const sPriceResult = await getDataWithComp(
        'Tb_Set_ItemSPrice',
        `AND sp_id = ${nArSpriceId} AND item_id = ${nItemId}`
      );

      if (sPriceResult && sPriceResult.length > 0) {
        const firstSPriceRow = sPriceResult[0];
        nProQty = firstSPriceRow?.pro_qty || 0.0;
        nProPrice = firstSPriceRow?.pro_price || 0.0;

        if (firstSPriceRow?.itemsp_price > 0.0) {
          itemPrice = firstSPriceRow.itemsp_price;
        }
      }
    }

    if (nProQty <= 0.0) {
      itemTotal = itemPrice * itemQty;
    } else {
      const n = Math.floor(itemQty / nProQty);
      itemTotal = n * nProPrice + (itemQty - n * nProQty) * itemPrice;
    }
  }

  return itemPrice;
};

export async function getDiscountForIce(itemList, arId) {
  try {
    const getArById = await getDataWithComp('Tb_Set_AR', `AND AR_Id = ${arId}`);
    if (getArById && getArById.length > 0) {
      if (getArById[0].AR_ICE_Pro) {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/sp_get_pro_discount`,
          {
            comp_id: localStorage.getItem('company'),
            pro_code: getArById[0].AR_ICE_Pro,
            item_1: itemList[0]?.itemCode || "101",
            qty_1: parseCurrency(itemList[0]?.itemQty) || 0,
            price_1: itemList[0]?.itemPriceUnit || 0,
            item_2: itemList[1]?.itemCode || "102",
            qty_2: parseCurrency(itemList[1]?.itemQty) || 0,
            price_2: itemList[1]?.itemPriceUnit || itemList[0]?.itemPriceUnit,
            item_3: itemList[2]?.itemCode || "103",
            qty_3: parseCurrency(itemList[2]?.itemQty) || 0,
            price_3: itemList[2]?.itemPriceUnit || itemList[0]?.itemPriceUnit,
            item_4: itemList[3]?.itemCode || "104",
            qty_4: parseCurrency(itemList[3]?.itemQty) || 0,
            price_4: itemList[3]?.itemPriceUnit || itemList[0]?.itemPriceUnit,
          },
          {
            headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
          }
        );
        return response.data[0].Total_discount;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  } catch (error) {
    console.debug("Error fetching data:", error);
    return 0;
  }
};

// Update Status ในข้อมูล
export async function updateStatusByNo(table, field, status, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-status`,
      {
        table: table,
        field: field,
        status: status,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// Update Qty ในข้อมูล
export async function updateQty(table, updateCode, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-qty`,
      {
        table: table,
        update_code: updateCode,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// Insert ข้อมูลด้วย Table, Field, Values
export async function insertData(table, field, values) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/create-data`,
      {
        table: table,
        field: field,
        values: values,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// Update ข้อมูลด้วย Table, Values, Where
export async function updateData(table, values, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-data`,
      {
        table: table,
        values: values,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// Delete ข้อมูลด้วย Table, Where
export async function deleteData(table, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/delete`,
      {
        table: table,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ฟังชั่นการสร้าง Tb_Set_Rec_No ใช้ชั่วคราว (จากพี่แบงค์)
export async function createSetRecNo(recNo) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/create-tb-set-rec-no`,
      {
        rec_no: recNo,
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ฟังชั่นการเรียกใช้ SP_RUN_NUMBER ของ Store Procedure (ของพี่สมบัติ)
export async function getSpRunNumber(prefix, yearmonth) {
  try {
    let ym = yearmonth;
    if (!ym) {
      const { currentYear, currentMonth } = getCurrentYearMonth();
      ym = `${currentYear}${currentMonth}`;
    }

    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/sp_run_number`,
      {
        comp_id: localStorage.getItem("company"),
        yearmonth: ym,
        prefix: prefix,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data.run_number;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ฟังชั่นกด ESC แล้วปิด Modal (ลองทดสอบดูก่อน)
export function useEscapeClose(isOpen, onClose) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);
}

// ฟังชั่นการเคลียร์ localStorage ของหน้ารายการ (เคสพี่คิน)
export async function getClearLocalStorage() {
  try {
    localStorage.removeItem("searchTerm");
    localStorage.removeItem("selectedRow");
    localStorage.removeItem("sortColumn");
    localStorage.removeItem("sortOrder");
    localStorage.removeItem("startDate");
    localStorage.removeItem("endDate");
    localStorage.removeItem("itemsPerPageDropdown");
    localStorage.removeItem("currentPage");
  } catch (error) {
    console.error("error:", error);
  }
}

export async function uploadSlip(base64Image, docId, docCodeId) {
  try {
    const filesPayload = Array.isArray(base64Image)
      ? base64Image.filter((f) => f != null)
      : base64Image
        ? [base64Image]
        : [];

    await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/upload-file`,
      {
        comp_id: localStorage.getItem("company"),
        doc_id: docId,
        DocCode_ID: docCodeId,
        upload_by: localStorage.getItem("emp_name"),
        file_status: "Y",
        files: filesPayload,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
  } catch (error) {
    console.error("error:", error);
  }
}

export async function uploadMultipleSlips(slipFiles, docId, docCodeId) {
  try {
    // Validate input
    if (!slipFiles || slipFiles.length === 0) {
      throw new Error("No files provided for upload");
    }

    if (slipFiles.length > 100) {
      throw new Error("Maximum 100 files allowed");
    }

    // Get payment history data
    let payHistory = [];
    const tryFetchPayHistory = async (payTypeOnly = true) =>
      await getDataWithComp(
        "Pay_History",
        payTypeOnly
          ? `AND DocCode_Id = ${docCodeId} AND Doc_Id = ${docId} AND Pay_Type = 2`
          : `AND DocCode_Id = ${docCodeId} AND Doc_Id = ${docId}`
      );

    const maxAttempts = 5;
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      payHistory = await tryFetchPayHistory(true);
      if (payHistory && payHistory.length > 0) break;
      await new Promise((res) => setTimeout(res, 200));
    }

    if (!payHistory || payHistory.length === 0) {
      payHistory = await tryFetchPayHistory(false);
    }

    if (!payHistory || payHistory.length === 0) {
      try {
        await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
          {
            doc_code_id: docCodeId,
            doc_id: docId,
            pay_type: 2,
            pay_amount: 0,
            pay_remark: null,
            pay_datetime: new Date().toISOString(),
            pay_by: window.localStorage.getItem("name") || null,
            pay_to_acc_no: null,
            pay_to_branch: null,
            pay_to_acc_name: null,
            pay_cheque_no: null,
            pay_cheque_name: null,
            pay_cheque_branch: null,
            pay_cheque_date: null,
            pay_cheque_type: null,
            comp_id: window.localStorage.getItem("company") || null,
            bank_master_id: null,
            bank_id: null,
            doc_ref: null,
          },
          { headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" } }
        );

        // ดึงข้อมูล payHistory ใหม่หลังจาก insert
        payHistory = await tryFetchPayHistory(false);
      } catch (insertErr) {
        console.error("Error creating Pay_History fallback:", insertErr);
        throw new Error("ไม่พบข้อมูล Pay_History สำหรับอัพโหลดไฟล์");
      }
    }

    // Prepare the request payload
    const payload = {
      comp_id: localStorage.getItem("company"),
      doc_id: docId,
      doccode_id: docCodeId,
      upload_by: localStorage.getItem("emp_name"),
      file_status: "Y",
      doc_no_ref: payHistory[0].Pay_His_Id,
    };

    // กรองไฟล์ที่ไม่ใช่ null/undefined และแปลงเป็น array
    const validFiles = slipFiles.filter((file) => file != null);

    if (validFiles.length === 0) {
      throw new Error("No valid files found for upload");
    }

    // ส่งไฟล์เป็น array ตาม API format ใหม่
    payload.files = validFiles;

    // เรียก API /upload-files
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/upload-files-slip`,
      payload,
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading multiple slips:", error);
    throw error;
  }
}

export async function getMultipleSlips(docId, docCodeId) {
  try {
    const files = await getData(
      "Upload_File_List",
      `DocCode_Id = ${docCodeId} AND Doc_ID = ${docId} ORDER BY Upload_Date ASC`
    );

    if (!files || files.length === 0) {
      return [];
    }

    return files.map((file, index) => {
      return {
        id: file.F_Id, // ✅ ใช้ F_Id เป็น primary key
        fileName: file.File_Name,
        fileUrl: file.File_Url,
        uploadDate: file.Upload_Date,
        uploadBy: file.Upload_By,
      };
    });
  } catch (error) {
    console.error("Error getting multiple slips:", error);
    throw error;
  }
}

export async function deleteSingleSlip(fileId) {
  try {
    console.log("🗑️ Deleting file F_Id:", fileId);

    // ✅ ใช้ F_Id แทน ID
    await deleteData("Upload_File_List", `WHERE F_Id = ${fileId}`);

    console.log("✅ Delete completed");
    return { status: "OK", message: "ลบไฟล์สำเร็จ" };
  } catch (error) {
    console.error("❌ Error deleting single slip:", error);
    throw error;
  }
}


export async function uploadArImage(base64Images, arId) {
  try {
    // ตรวจสอบว่า base64Images เป็น array หรือ string เดี่ยว
    let files;
    if (Array.isArray(base64Images)) {
      files = base64Images; // หลายไฟล์
    } else {
      files = base64Images; // ไฟล์เดี่ยว
    }

    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/upload-ar-image`,
      {
        comp_id: localStorage.getItem("company"),
        ar_id: arId,
        upload_by: localStorage.getItem("emp_id"),
        files: files,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading AR image:", error);
    throw error;
  }
}

export async function DeleteArImage(url) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/deleteArImage`,
      {
        image_url: url,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting AR image:", error);
    throw error;
  }
}